import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import {
  appendSectionHeadlineReveal,
  SECTION_HEADLINE_DURATION,
} from "./section-headline-gsap.js";

gsap.registerPlugin(ScrollTrigger);

const reducedMotion = window.matchMedia(
  "(prefers-reduced-motion: reduce)",
).matches;

/** Matches `styles/_variables` `$screen-sm` */
const MIN_WIDTH_DESKTOP = 768;

/**
 * How many seconds the *next* bridge starts before the previous motion finishes.
 * Larger = more “one continuous flow”, less STEP–pause–STEP (lines + steps overlap heavily).
 */
const BRIDGE_OVERLAP = 0.22;

if (!reducedMotion) {
  document.querySelectorAll(".steps").forEach((section) => {
    const itemList = section.querySelectorAll(".steps__item");
    if (!itemList.length) {
      return;
    }

    const items = Array.from(itemList);
    const headline = section.querySelector(
      ".steps__headline.page-section__headline, .page-section__headline",
    );

    gsap.context(() => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: section,
          start: "top 85%",
          toggleActions: "play none none none",
        },
      });

      const hasHeadline = appendSectionHeadlineReveal(tl, headline, 0, {
        withRule: true,
      });

      // Begin steps slightly before the headline tween ends — tighter than a post-headline gap.
      const firstStepTime = hasHeadline
        ? SECTION_HEADLINE_DURATION - 0.08
        : 0.05;

      const isDesktop = window.innerWidth >= MIN_WIDTH_DESKTOP;

      if (isDesktop) {
        const dFirst = 0.28;
        // Slightly longer strokes so overlapping waves don’t feel rushed; overlap does the “flow”.
        const dBridge = 0.32;
        const easeText = "power2.out";

        const firstIcon = items[0].querySelector(".steps__item-icon-wrapper");
        const firstCont = items[0].querySelector(".steps__item-content");
        if (firstIcon) {
          tl.fromTo(
            firstIcon,
            { autoAlpha: 0 },
            { autoAlpha: 1, duration: dFirst, ease: "sine.out", force3D: true },
            firstStepTime,
          );
        }
        if (firstCont) {
          tl.fromTo(
            firstCont,
            { autoAlpha: 0, y: 16 },
            {
              autoAlpha: 1,
              y: 0,
              duration: dFirst,
              ease: easeText,
              force3D: true,
            },
            firstStepTime,
          );
        }

        for (let k = 0; k < 3; k += 1) {
          const line = items[k].querySelector(".steps__item-line");
          const next = items[k + 1];
          if (!line || !next) {
            break;
          }
          const nIcon = next.querySelector(".steps__item-icon-wrapper");
          const nCont = next.querySelector(".steps__item-content");
          if (!nIcon) {
            break;
          }

          // Same overlap after first step and between bridges (continuous “wave”, not stair-stepped).
          const at = `>-${String(BRIDGE_OVERLAP)}`;

          // Line: linear-ish draw reads like one ongoing stroke while other bridges overlap in time.
          tl.fromTo(
            line,
            { scaleX: 0, transformOrigin: "left center" },
            {
              scaleX: 1,
              duration: dBridge,
              ease: "none",
              force3D: true,
            },
            at,
          );
          tl.fromTo(
            nIcon,
            { autoAlpha: 0 },
            {
              autoAlpha: 1,
              duration: dBridge,
              ease: "sine.out",
              force3D: true,
            },
            at,
          );
          if (nCont) {
            tl.fromTo(
              nCont,
              { autoAlpha: 0, y: 10 },
              {
                autoAlpha: 1,
                y: 0,
                duration: dBridge,
                ease: easeText,
                force3D: true,
              },
              at,
            );
          }
        }
      } else {
        const dM = 0.3;
        items.forEach((item, i) => {
          const mIcon = item.querySelector(".steps__item-icon-wrapper");
          const mCont = item.querySelector(".steps__item-content");
          const pos =
            i === 0 ? firstStepTime : `>-${String(BRIDGE_OVERLAP * 0.65)}`;
          if (mIcon) {
            tl.fromTo(
              mIcon,
              { autoAlpha: 0 },
              { autoAlpha: 1, duration: dM, ease: "sine.out", force3D: true },
              pos,
            );
          }
          if (mCont) {
            tl.fromTo(
              mCont,
              { autoAlpha: 0, y: 18 },
              {
                autoAlpha: 1,
                y: 0,
                duration: dM,
                ease: "power2.out",
                force3D: true,
              },
              pos,
            );
          }
        });
      }
    }, section);
  });
}


